import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MotifIcon } from '../../icon/icon';
import { MotifDropdownItem } from '../../dropdown/dropdown-item/dropdown-item';
import { ReactComponent as NavigationIcChevronRight24px } from '../../../assets/icons/navigation/ic_chevron_right_24px.svg';

const defaultIcons = {
  separator: <NavigationIcChevronRight24px />
};

/**
 * @typedef Props
 * @prop  {React.ReactNode} children
 * @prop  {string} [icon]
 * @prop  {{separator: React.ReactNode}} [icons]
 * @prop  {string} [className]
 * @prop {boolean} [disabled]
 * @prop {'default' | 'alt'} [variant]
 * @prop {number} [itemIndex]
 * @prop {number} [itemsLength]
 * @prop {boolean} [isTruncated]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifBreadcrumbItem = (props) => {
  const {
    children,
    className = '',
    icon = '',
    icons: userIcons = {},
    disabled = false,
    variant = 'default',
    itemIndex = null,
    itemsLength = null,
    isTruncated = false,
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const isLastChild = itemIndex + 1 === itemsLength;
  const isfirstChild = itemIndex === 0;
  const classes = classNames({
    'motif-breadcrumb-list-item': true,
    'motif-breadcrumb-list-item-active': isLastChild,
    'motif-breadcrumb-list-item-disabled': disabled,
    'motif-breadcrumb-list-item-alt': variant === 'alt',
    [className]: true
  });

  const properties = {
    className: classes,
    ...other
  };

  if (isLastChild) {
    properties['aria-current'] = 'page';
  }

  return isTruncated ? (
    <MotifDropdownItem {...properties} aria-disabled={disabled}>
      {icon && <MotifIcon src={icon} />}
      {children}
    </MotifDropdownItem>
  ) : (
    <li {...properties} aria-disabled={disabled}>
      {!isfirstChild && <span className="motif-breadcrumb-separator">{icons.separator}</span>}
      {icon && <MotifIcon src={icon} />}
      {children}
    </li>
  );
};

MotifBreadcrumbItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  icons: PropTypes.shape({
    separator: PropTypes.node
  }),
  itemIndex: PropTypes.number,
  itemsLength: PropTypes.number,
  isTruncated: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'alt'])
};

export { MotifBreadcrumbItem };
